import { useState } from "react"
import { Modal, Typography, Button, Space } from "antd"
import { RocketOutlined, ArrowRightOutlined } from "@ant-design/icons"

const { Title, Paragraph } = Typography

export default function WelcomeModal({startTour, skipTutorial}) {
  const [isVisible, setIsVisible] = useState(true)

  const handleSkipTour = () => {
    setIsVisible(false)
    skipTutorial()
  }

  return (
      <Modal
        open={isVisible}
        onCancel={handleSkipTour}
        footer={null}
        centered
        width={520}
        closable={false}
        maskClosable={false}
        className="welcome-modal"
      >
        <div style={{ textAlign: "center", padding: "20px 0" }}>
          {/* Header with icon */}
          <div style={{ marginBottom: "24px" }}>
            <RocketOutlined
              style={{
                fontSize: "48px",
                color: "#1890ff",
                marginBottom: "16px",
                display: "block",
              }}
            />
            <Title level={2} style={{ margin: 0, color: "#262626" }}>
              Welcome to Your Command Center
            </Title>
          </div>

          {/* Body text */}
          <div style={{ marginBottom: "32px" }}>
            <Paragraph
              style={{
                fontSize: "16px",
                lineHeight: "1.6",
                color: "#595959",
                margin: 0,
              }}
            >
              Radar+ is now live and scanning your connected tools for strategic risks and opportunities. Let's walk you
              through the key areas — or skip ahead and dive in on your own.
            </Paragraph>
          </div>

          {/* Action buttons */}
          <Space size="middle" direction="vertical" style={{ width: "100%" }}>
            <Button
              type="primary"
              size="large"
              icon={<ArrowRightOutlined />}
              onClick={() => {
                setIsVisible(false)
                startTour()
              }}
              style={{
                width: "280px",
                height: "48px",
                fontSize: "16px",
                fontWeight: "500",
              }}
            >
              Show Me Around
            </Button>

            <Button
              type="text"
              size="large"
              onClick={handleSkipTour}
              style={{
                width: "280px",
                height: "40px",
                fontSize: "14px",
                color: "#8c8c8c",
              }}
            >
              Skip Tour
            </Button>
          </Space>
        </div>
      </Modal>
  )
}
